import axios from "axios"
import UtenteMasterDTO from "../../interfaces/UtenteMasterDTO"

export const createUtenteMaster = (formValues: UtenteMasterDTO) => {
  return new Promise((resolve, reject) => {
    axios
      .post(`/api/UtenteMaster`, formValues)
      .then(() => {
        resolve(true)
      })
      .catch((error) => {
        reject(error.response.data.response)
      })
  })
}
export default createUtenteMaster
